export default () => {
  const data = {
    event_name: 'click',
    button_name: 'next_properties',
    page_section: 'real_estate',
    name_of_the_page_viewed: 'home_personal',
  };
  return data;
};
